(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-landing-collapsable"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const buttons = document.querySelectorAll('.landing-collapsable-read-more-btn');
    buttons.forEach(button => {
      button.addEventListener('click', function () {
        const blockId = this.getAttribute('data-block-id');
        const preview = document.getElementById(`preview-${blockId}`);
        const full = document.getElementById(`full-${blockId}`);
        const block = document.getElementById(`block-${blockId}`);
        if (full.style.display === 'none') {
          full.style.display = 'block';
          preview.style.display = 'none';
          this.textContent = 'Read Less';
        } else {
          full.style.display = 'none';
          preview.style.display = 'block';
          this.textContent = 'Read More';
          block.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  });
  
  } catch(e) { console.error(e); }
})();
})();
